'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardHeader = require('../ContentCardHeader');

var _ContentCardHeader2 = _interopRequireDefault(_ContentCardHeader);

var _ContentCardGallery = require('../ContentCardGallery');

var _ContentCardGallery2 = _interopRequireDefault(_ContentCardGallery);

var _ContentCardText = require('../ContentCardText');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

var _withContentCardFooter = require('../../hocs/withContentCardFooter');

var _withContentCardFooter2 = _interopRequireDefault(_withContentCardFooter);

var _TwitterDetails = require('../TwitterDetails/TwitterDetails');

var _TwitterDetails2 = _interopRequireDefault(_TwitterDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwitterGalleryContentCard = function TwitterGalleryContentCard(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_ContentCardHeader2.default, { iconType: 'twitter' }),
    _react2.default.createElement(_ContentCardGallery2.default, {
      images: props.images,
      alt: props.text
    }),
    _react2.default.createElement(_TwitterDetails2.default, {
      authorHandle: props.authorHandle,
      authorName: props.authorName,
      url: props.url,
      verified: props.verified,
      profileUrl: props.profileUrl,
      profileImageUrl: props.profileImageUrl
    }),
    _react2.default.createElement(_ContentCardText2.default, {
      text: props.text,
      caption: props.caption,
      url: props.url,
      verified: props.verified,
      isLarge: props.isLarge
    }),
    props.messengerShareButton
  );
};

TwitterGalleryContentCard.propTypes = {
  authorHandle: _propTypes2.default.string.isRequired,
  authorName: _propTypes2.default.string.isRequired,
  images: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  messengerShareButton: _propTypes2.default.node,
  profileUrl: _propTypes2.default.string.isRequired,
  profileImageUrl: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired,
  verified: _propTypes2.default.bool.isRequired,
  caption: _propTypes2.default.string,
  isLarge: _propTypes2.default.bool
};

TwitterGalleryContentCard.defaultProps = {
  messengerShareButton: null,
  caption: null,
  isLarge: false
};

TwitterGalleryContentCard.displayName = 'TwitterGalleryContentCard';

exports.default = (0, _withContentCardFooter2.default)(TwitterGalleryContentCard);